import { ApiService } from '@libs/core/base-config';
import { Dtos, getSharedCartResponseSchema, shareCartResponseSchema } from '@libs/mtjr/shared/generated/types';
import { map } from 'rxjs';

export function shareCart(apiService: ApiService, { items }: Dtos.SharedCartBody) {
  return apiService.http
    .post(`${apiService.baseUrl}/api/v1/shared-carts/share-cart`, { items })
    .pipe(map((data) => shareCartResponseSchema().parse(data)));
}

export function getSharedCart(apiService: ApiService, { id }: Dtos.GetSharedCartPathParams) {
  return apiService.http
    .get(`${apiService.baseUrl}/api/v1/shared-carts/get-shared-cart/${id}`, {})
    .pipe(map((data) => getSharedCartResponseSchema().parse(data)));
}
